import { render } from "./AboutList.vue?vue&type=template&id=4e48aba7&scoped=true&ts=true"
import script from "./AboutList.vue?vue&type=script&lang=ts"
export * from "./AboutList.vue?vue&type=script&lang=ts"

import "./AboutList.vue?vue&type=style&index=0&id=4e48aba7&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e48aba7"]])

export default __exports__